import dayjs from 'dayjs'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useIsMobile } from '../hooks/useMediaQuery'

type Props = {
  // Date in formato YYYY-MM-DD, '' se non impostate
  start: string
  end: string
  onChange: (start: string, end: string) => void
  placeholder?: string
}

// Filtro per intervallo di date: su desktop react-datepicker con selezione dell'intervallo,
// su mobile due campi data nativi ("Dal" / "Al") che aprono il selettore del telefono
export default function DateRangeField({ start, end, onChange, placeholder = 'Seleziona periodo' }: Props) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className="d-flex flex-column gap-2 date-range-native">
        <input
          type="date"
          className="form-control text-secondary"
          aria-label="Dal"
          value={start}
          max={end || undefined}
          onChange={(e) => onChange(e.target.value, end && e.target.value > end ? '' : end)}
        />
        <input
          type="date"
          className="form-control text-secondary"
          aria-label="Al"
          value={end}
          min={start || undefined}
          onChange={(e) => onChange(start, e.target.value)}
        />
      </div>
    )
  }

  return (
    <ReactDatePicker
      selectsRange={true}
      isClearable
      placeholderText={placeholder}
      className="form-control me-2 text-secondary"
      startDate={start !== '' ? dayjs(start).toDate() : null}
      endDate={end !== '' ? dayjs(end).toDate() : null}
      dateFormat={'dd/MM/yyyy'}
      onChange={(date) => {
        if (!date[0]) {
          onChange('', '')
        } else {
          onChange(dayjs(date[0]).format('YYYY-MM-DD'), date[1] ? dayjs(date[1]).format('YYYY-MM-DD') : '')
        }
      }}
    />
  )
}
